import BigNumber from 'bignumber.js'

export const fromGwei = (gwei: number): BigNumber => {
  const ether = BigNumber(gwei).dividedBy(10 ** 9)
  return ether
}
